import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PredefinedDateRanges from "../../../core/common/datePicker";
import moment from "moment";
import { Moment } from "moment";
import dayjs from "dayjs";
import { DatePicker, TimePicker } from "antd";

const MyattendanceHistory = () => {

  function formatHours(hoursDecimal: number): string {
    const hours = Math.floor(hoursDecimal);
    const minutes = Math.floor((hoursDecimal - hours) * 60);
    const seconds = Math.round(((hoursDecimal - hours) * 60 - minutes) * 60);

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }
  // :${seconds.toString().padStart(2, "0")}


  const [attendance, setAttendance] = useState([]);
  const [modalData, setModalData] = useState<any>([]);
  const [callAgain, setCallAgain] = useState(0);
  const [reguStatus, setReguStatus] = useState("")
  const [selectedDateRange, setSelectedDateRange] = useState<{
    from: string;
    to: string;
  }>({
    from: moment().startOf('month').format("YYYY-MM-DD"),
    to: moment().endOf('month').format("YYYY-MM-DD"),
  });
  const [reguDate, setReguDate] = useState<dayjs.Dayjs | null>(dayjs());
  const [inTime, setInTime] = useState<dayjs.Dayjs | null>(
    dayjs("09:00:00", "HH:mm:ss")
  );
  const [outTime, setOutTime] = useState<dayjs.Dayjs | null>(
    dayjs("19:00:00", "HH:mm:ss")
  );

  const [reason, setReason] = useState("");


  const {
    data: attendanceData,
    loading: attendanceLoading,
    error: attendanceErrro,
  } = useApi("/api/attendance-details", {
    method: "POST",
    payload: selectedDateRange,
    autoCall: true,
    dependencies: [selectedDateRange]
  });
  useEffect(() => {
    if (attendanceData?.success) {
      setAttendance(attendanceData?.data);
    }
  }, [attendanceData]);

  const columns = [
    {
      title: "Date",
      dataIndex: "attendance_date",
      render: (text: string) => dayjs(text).format("D MMMM YYYY"), // 👉 10 October 2025
      sorter: (a: any, b: any) =>
        dayjs(a.attendance_date).unix() - dayjs(b.attendance_date).unix(),
    },
    {
      title: "Shift",
      dataIndex: "shift",
    },
    {
      title: "Shift Time",
      dataIndex: "start_time",
      render: (_: any, record: any) =>
        `${record.start_time} - ${record.end_time}`,
    },
    {
      title: "Punch In",
      dataIndex: "punchin_time_software",
      render: (_: any, record: any) => {
        if (record.regularisation_status === "APPROVED") {
          return record.manager_regn_in_time || "-";
        }
        return (
          record.in_time_machine ||
          record.punchin_time_software ||
          record.self_regn_in_time ||
          "-"
        );
      },
      sorter: (a: any, b: any) =>
        new Date(
          a.manager_regn_in_time ||
          a.in_time_machine ||
          a.punchin_time_software
        ).getTime() -
        new Date(
          b.manager_regn_in_time ||
          b.in_time_machine ||
          b.punchin_time_software
        ).getTime(),
    },
    {
      title: "Punch Out",
      dataIndex: "punchout_time_software",
      render: (_: any, record: any) => {
        if (record.regularisation_status === "APPROVED") {
          return record.manager_regn_out_time || "-";
        }
        return (
          record.out_time_machine ||
          record.punchout_time_software ||
          record.self_regn_out_time ||
          "-"
        );
      },
      sorter: (a: any, b: any) =>
        new Date(
          a.manager_regn_out_time ||
          a.out_time_machine ||
          a.punchout_time_software
        ).getTime() -
        new Date(
          b.manager_regn_out_time ||
          b.out_time_machine ||
          b.punchout_time_software
        ).getTime(),
    },
    {
      title: "Hours",
      dataIndex: "hours_machine",
      render: (_: any, record: any) => {
        let hoursDisplay = "00:00";

        //  Case 1: Manager regularisation approved — use manager_regn_hours directly
        if (record.regularisation_status === "APPROVED" && record.manager_regn_hours) {
          hoursDisplay = `${record.manager_regn_hours}`;
        }
        //  Case 2: Normal case — use machine/software/self-regn hours and format
        else {
          const hoursDecimal = parseFloat(
            record.hours_machine ||
            record.hours_software ||
            record.self_regn_hours ||
            "0"
          );
          hoursDisplay = hoursDecimal > 0 ? formatHours(hoursDecimal) : "00:00";
        }

        return hoursDisplay;
      },
      sorter: (a: any, b: any) => {
        const getHours = (rec: any) => {
          if (rec.regularisation_status === "APPROVED") {
            return parseFloat(rec.manager_regn_hours || "0");
          }
          return parseFloat(
            rec.hours_machine || rec.hours_software || rec.self_regn_hours || "0"
          );
        };
        return getHours(a) - getHours(b);
      },
    }
    ,
    {
      title: "Status",
      dataIndex: "status",
      render: (_text: string, record: any) => {
        // Show holiday name if exists
        if (record.h_name) {
          return (
            <span className="badge bg-info text-light">
              {record.h_name}
            </span>
          );
        }

        // Determine badge color based on exact status
        let badgeColor = "";
        switch (record.status) {
          case "P":
            badgeColor = "rgb(40, 167, 69)"; // Green
            break;
          case "HP":
            badgeColor = "rgb(253, 126, 20)"; // Orange
            break;
          case "A":
            badgeColor = "red"; // Red
            break;
          case "SH":
            badgeColor = "rgb(255, 193, 7)";
            break;
          default:
            badgeColor = "rgb(0, 123, 255)"; // Default Blue
        }

        return (
          <span className="badge text-light" style={{ backgroundColor: badgeColor }}>
            {record.status}
          </span>
        );
      },
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    }

    ,
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <>
          <Link
            to="#"
            className="text-primary me-2"
            title="Regularization"
            data-bs-toggle="modal"
            data-bs-target="#attendanceModal"
            onClick={() => {
              setReguDate(dayjs(record.attendance_date));
              const punchIn =
                record.in_time_machine || record.punchin_time_software || null;
              setInTime(punchIn ? dayjs(punchIn, "HH:mm:ss") : null);
              const punchOut =
                record.out_time_machine || record.punchout_time_software || null;
              setOutTime(punchOut ? dayjs(punchOut, "HH:mm:ss") : null);
            }}
          >
            <i className="ti ti-circle-check" />
          </Link>
          {/* <Link
            to="#"
            className="text-success me-2"
            title="View Details"
            data-bs-toggle="modal"
            data-bs-target="#apply-modal"
            onClick={() => setModalData(record)}
          >
            <i className="ti ti-eye" />
          </Link> */}
        </>
      ),
    },
  ];

  const {
    data: addReguData,
    loading: addReguLoading,
    error: addReguErrro,
    callApi: AddReguRecord,
  } = useApi("/api/regularization-attendace", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: any) => {
    e.preventDefault()
    try {
      if (!reguDate || !inTime || !outTime) {
        console.error("Date or Time values are missing");
        return;
      }
      const payload = {
        attendance_regn_date: reguDate.format("YYYY-MM-DD"),
        self_regn_in_date: reguDate.format("YYYY-MM-DD"),
        self_regn_in_time: inTime.format("HH:mm:ss"),
        self_regn_out_date: reguDate.format("YYYY-MM-DD"),
        self_regn_out_time: outTime.format("HH:mm:ss"),
        reason: reason,
      };

      const response = await AddReguRecord(payload);

      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "Submitted!",
          text: response?.message || "Regularization submitted successfully.",
          timer: 2000,
          showConfirmButton: true,
        });
        document.getElementById("closed_modal")?.click();
        setReason("")
        setOutTime(dayjs("19:00:00", "HH:mm:ss"));
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message || "Something went wrong!",
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data.message || "Something went wrong!",
      });
    }
  };


  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Attendance History</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Attendance History List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-end flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges
                      onChange={(start: Moment, end: Moment) => {
                        setSelectedDateRange({
                          from: start.format("YYYY-MM-DD"),
                          to: end.format("YYYY-MM-DD"),
                        });
                      }}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>


              </div>
            </div>

            <div className="card-body p-0">
              <Table limit={31} dataSource={attendance} columns={columns} Selection={false} showSearchInput={true} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="attendanceModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={postData}>
              <div className="modal-header">
                <h4 className="modal-title" id="exampleModalLgLabel">
                  Attendance Regularization
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closed_modal"
                />
              </div>
              <div className="modal-body">
                <div className="row mt-3 mb-3">
                  {/* In Time */}
                  <div className="col-md-12 d-flex align-items-center gap-3">
                    <label className="form-label w-25">In Time</label>
                    <div className="input-icon-end position-relative flex-grow-1">
                      <DatePicker
                        className="form-control datetimepicker"
                        format="YYYY-MM-DD"
                        value={reguDate}
                        onChange={(date) => setReguDate(date)}
                        placeholder="YYYY-MM-DD"
                        disabled
                      // disabledDate={(current) => {
                      //   return current && current >= dayjs().startOf("day");
                      // }}
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                    <TimePicker
                      className="form-control w-25"
                      value={inTime}
                      onChange={(value) => setInTime(value)}
                      format="HH:mm:ss"
                      allowClear={false}
                    />
                  </div>

                  {/* Out Time */}
                  <div className="col-md-12 d-flex align-items-center gap-3 mt-3">
                    <label className="form-label w-25">Out Time</label>
                    <div className="input-icon-end position-relative flex-grow-1">
                      <DatePicker
                        className="form-control datetimepicker"
                        format="YYYY-MM-DD"
                        value={reguDate}
                        onChange={(date) => setReguDate(date)}
                        placeholder="YYYY-MM-DD"
                        disabled
                      // disabledDate={(current) => {
                      //   return current && current >= dayjs().startOf("day");
                      // }}
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                    <TimePicker
                      className="form-control w-25"
                      value={outTime}
                      onChange={(value) => setOutTime(value)}
                      format="HH:mm:ss"
                      allowClear={false}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Reason</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      placeholder="Enter Reason......"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      required
                    ></textarea>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Total Hours</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g. 08:00:00"
                      value={
                        inTime && outTime && outTime.isAfter(inTime)
                          ? (() => {
                            const diffSeconds = outTime.diff(inTime, "second");
                            const hrs = Math.floor(diffSeconds / 3600);
                            const mins = Math.floor((diffSeconds % 3600) / 60);
                            const secs = diffSeconds % 60;
                            return `${hrs.toString().padStart(2, "0")}:${mins
                              .toString()
                              .padStart(2, "0")}:${secs
                                .toString()
                                .padStart(2, "0")}`;
                          })()
                          : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-secondary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>


      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="apply-modalLabel">
                Regularization Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {modalData &&
                (
                  modalData.attendance_regn_date ||
                  modalData.shift_start_time ||
                  modalData.self_regn_in_date ||
                  modalData.self_regn_in_time ||
                  modalData.self_regn_out_date ||
                  modalData.self_regn_out_time ||
                  modalData.self_regn_hours ||
                  modalData.manager_regn_in_date ||
                  modalData.manager_regn_in_time ||
                  modalData.manager_regn_out_date ||
                  modalData.manager_regn_out_time ||
                  modalData.manager_regn_hours ||
                  modalData.regularisation_status ||
                  modalData.reason ||
                  modalData.manager_reason ||
                  modalData.approved_by ||
                  modalData.rejected_by ||
                  modalData.created_on
                ) ? (
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <strong>Attendance Date:</strong>
                    <p className="text-muted">
                      {modalData?.attendance_regn_date || "N/A"}
                    </p>
                  </div>

                  <div className="col-md-6 mb-3">
                    <strong>Shift Time:</strong>
                    <p className="text-muted">
                      {modalData?.shift_start_time} - {modalData?.shift_end_time}
                    </p>
                  </div>

                  <div className="col-md-6 mb-3">
                    <strong>Self In Time:</strong>
                    <p className="text-muted">
                      {modalData?.self_regn_in_date}{" "}
                      {modalData?.self_regn_in_time}
                    </p>
                  </div>

                  <div className="col-md-6 mb-3">
                    <strong>Self Out Time:</strong>
                    <p className="text-muted">
                      {modalData?.self_regn_out_date}{" "}
                      {modalData?.self_regn_out_time}
                    </p>
                  </div>

                  <div className="col-md-6 mb-3">
                    <strong>Total Self Hours:</strong>
                    <p className="text-muted">
                      {modalData?.self_regn_hours || "N/A"}
                    </p>
                  </div>

                  {(modalData?.manager_regn_in_date ||
                    modalData?.manager_regn_in_time ||
                    modalData?.manager_regn_out_date ||
                    modalData?.manager_regn_out_time ||
                    modalData?.manager_regn_hours) && (
                      <>
                        <div className="col-md-12">
                          <h6 className="mt-2 mb-3 text-primary">
                            Manager Attendance Details
                          </h6>
                        </div>

                        <div className="col-md-6 mb-3">
                          <strong>Manager In Time:</strong>
                          <p className="text-muted">
                            {modalData?.manager_regn_in_date || "--"}{" "}
                            {modalData?.manager_regn_in_time || "--"}
                          </p>
                        </div>

                        <div className="col-md-6 mb-3">
                          <strong>Manager Out Time:</strong>
                          <p className="text-muted">
                            {modalData?.manager_regn_out_date || "--"}{" "}
                            {modalData?.manager_regn_out_time || "--"}
                          </p>
                        </div>

                        <div className="col-md-6 mb-3">
                          <strong>Total Manager Hours:</strong>
                          <p className="text-muted">
                            {modalData?.manager_regn_hours || "N/A"}
                          </p>
                        </div>
                      </>
                    )}

                  <div className="col-md-6 mb-3">
                    <strong>Status:</strong>
                    <p>
                      <span
                        className={`badge ${modalData?.regularisation_status === "APPROVED"
                          ? "bg-success"
                          : modalData?.regularisation_status === "REJECTED"
                            ? "bg-danger"
                            : "bg-danger"
                          }`}
                      >
                        {modalData?.regularisation_status || "PENDING"}
                      </span>
                    </p>
                  </div>

                  <div className="col-md-12 mb-3">
                    <strong>Reason:</strong>
                    <p className="text-muted">{modalData?.reason || "N/A"}</p>
                  </div>

                  {modalData?.manager_reason && (
                    <div className="col-md-12 mb-3">
                      <strong>Manager Reason:</strong>
                      <p className="text-muted">{modalData?.manager_reason}</p>
                    </div>
                  )}

                  <div className="col-md-6 mb-3">
                    <strong>Approved By:</strong>
                    <p className="text-muted">
                      {modalData?.approved_by || "N/A"}
                    </p>
                  </div>

                  <div className="col-md-6 mb-3">
                    <strong>Rejected By:</strong>
                    <p className="text-muted">
                      {modalData?.rejected_by || "N/A"}
                    </p>
                  </div>

                  <div className="col-md-12 mb-3">
                    <strong>Created On:</strong>
                    <p className="text-muted">
                      {new Date(modalData?.created_on).toLocaleString() || "N/A"}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5">
                  <h5 className="text-muted">No record found</h5>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyattendanceHistory;
